import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConquistaUsuarioResponse } from 'app/shared/models/ei-models';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConquistaService extends BaseService {
    private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Conquista/');

    constructor(private httpClient: HttpClient) {
        super();
    }

    listarMinhasConquistas(usuarioId: number): Observable<ConquistaUsuarioResponse[]> {
        return this.httpClient.get<ConquistaUsuarioResponse[]>(
            this.controllerEndpoint.concat('ListarConquistas/', usuarioId.toString()),
            { headers: this.getHeader(true) }
        );
    }

}